import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useIsMobile } from "@/hooks/use-mobile";
import { useLanguage } from "@/contexts/LanguageContext";

interface GalleryCardProps {
  image: { src: string; alt: string; title: string; number: string; category: string };
  onClick: () => void;
}

const GalleryCard = ({ image, onClick }: GalleryCardProps) => {
  const { t } = useLanguage();
  const isMobile = useIsMobile();
  const { ref, isVisible } = useScrollAnimation(0.3);

  return (
    <div
      ref={ref}
      className="group relative overflow-hidden rounded-xl aspect-square cursor-pointer transition-all duration-300 hover:shadow-[0_15px_40px_rgba(212,175,55,0.4)]"
      onClick={onClick}
    >
      <img
        src={image.src}
        alt={image.alt}
        loading="eager"
        decoding="sync"
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-125 group-hover:rotate-2"
      />
      
      {/* Gradient overlay */}
      <div
        className={`absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent transition-opacity duration-300 flex items-end ${
          isMobile ? "opacity-100" : "opacity-0 group-hover:opacity-100"
        }`}
      >
        <div
          className={`p-6 w-full relative z-20 transition-all duration-1000 ease-out ${
            isMobile
              ? isVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-8 opacity-0"
              : ""
          }`}
        >
          {image.number && (
            <p className="text-gold text-sm font-medium mb-1">
              {t("gallery.number")} {image.number}
            </p>
          )}
          <h3 className="text-2xl font-serif font-semibold text-gold">
            {image.title}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default GalleryCard;
